import { useState } from "react";
import { ListOfCards, TicketsTable } from "./components";
import styles from "./styles.module.scss";

export const Tickets = () => {
  return (
    <div className={styles.ticketsContainer}>
      <h2>Customer Tickets</h2>
      <ListOfCards />
      <TicketsTable />
    </div>
  );
};
